<template>
  <div class="m-0" v-if="isScreeningCatalogueAnalysisRequest">
    <div
      class="text-xs-center"
      v-if="displayComputationWidget && standalone === true"
    >
      <exo-mission-computation></exo-mission-computation>
    </div>
    <v-dialog v-if="displayError" v-model="dialog">
      <template v-slot:activator="{ on: dialog }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-col class="bug-btn-col">
              <v-btn large class="bug-button" v-on="{ ...dialog, ...tooltip }">
                <icon class="red--text" scale="1.5" name="user-injured" />
                <span class="red--text bug-btn-txt">Bug report</span>
              </v-btn>
            </v-col>
          </template>
          <span>Display bug report</span>
        </v-tooltip>
      </template>
      <error-log-display
        :root="_self"
        :computationLog="currentResultsLog"
      ></error-log-display>
    </v-dialog>
    <div v-if="displayResult && !displayError">
      <template v-if="standalone === true">
        <v-row>
          <v-col class="pb-3">
            <v-row no-gutters>
              <div class="d-inline-flex ml-3 justify-center align-center">
                <span class="headline grey--text">{{
                  currentMission.name.toUpperCase()
                }}</span>
              </div>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="mt-0"></v-divider>
      </template>
      <div class="px-3 pt-3" v-if="resultsLoaded">
        <ScreeningCatalogueAnalysisResultCard :events="detectedEvents" />
      </div>
      <div class="px-3 pt-3">
        <ScreeningCatalogueAnalysisDashboardTimeline :events="detectedEvents" />
      </div>
    </div>
  </div>
</template>

<script>
import dashboardComponents from '../../components/Dashboard/index.js'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import errorMixin from '../../mixins/logHandler.js'
import dataTools from '../../tools/data.js'
import dashboardTools from '../../tools/dashboard'
import ScreeningCatalogueAnalysisDashboardTimeline from './ScreeningCatalogueAnalysisDashboardTimeline'
import ScreeningCatalogueAnalysisResultCard from './ScreeningCatalogueAnalysisResultCard.vue'
Vue.use(dashboardComponents)

export default {
  name: 'ScreeningCatalogueAnalysisDashboard',
  mixins: [errorMixin],
  components: {
    ScreeningCatalogueAnalysisResultCard,
    ScreeningCatalogueAnalysisDashboardTimeline
  },
  data() {
    return {
      data: null,
      dialog: false,
      type: 'ScreeningCatalogueAnalysisResult'
    }
  },

  watch: {},

  mounted() {},

  props: {
    standalone: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      currentMission: 'currentMission',
      currentResultsLog: 'currentResultsLog'
    }),
    displayComputationWidget() {
      return this.computationNeeded || !this.resultsLoaded
    },
    displayResult() {
      return this.resultsLoaded && !this.computationNeeded
    },
    displayError() {
      return dashboardTools.displayError(this)
    },
    computationNeeded() {
      return (
        this.currentMission &&
        this.currentMission.computationRequested &&
        this.currentMission.computationLogId === ''
      )
    },
    resultsLoaded() {
      return (
        this.currentResultsLog != null && this.currentResultsLog.results != null
      )
    },
    resultAvailable() {
      return (
        this.resultsLoaded &&
        this.currentResultsLog.results ===
          Object(this.currentResultsLog.results)
      ) // check object, not array
    },
    computationLogId() {
      return this?.currentResultsLog?.id
    },
    detectedEvents() {
      const events = this?.currentResultsLog?.results?.analysisResult?.events
      return events != null ? events : []
    },
    isScreeningCatalogueAnalysisRequest() {
      return (
        this?.currentMission?.typeName === 'ScreeningCatalogueAnalysisRequest'
      )
    },
    eventTypes() {
      const types =
        dataTools.getResultFieldFromPath(['eventType'], 'AbstractEvent')
          ?.values ?? []
      return types.map((type) => type.value)
    }
  },
  methods: {}
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');

.bug-btn-txt {
  margin-left: 12px;
}

.bug-btn-col {
  text-align: center;
}
</style>
